export default () => ({
  title: "DonorCardImgByAmt",
  type: "object",
  noValidateChild: true,
  properties: {
    value: {
      title: "Active",
      type: "boolean",
      default: false,
    },
    thresholds: {
      type: "list",
      default: [],
      expanded: true,
      component: "DonorCardTiers",
    },
  },
});
